import { createFileRoute } from "@tanstack/react-router";
import { ComprovantesPage } from "@/pages/ComprovantesPage";

export const Route = createFileRoute("/comprovantes/")({
  head: () => ({
    meta: [
      { title: "Comprovantes — AXIS Comprovantes" },
      { name: "description", content: "Lista de comprovantes processados e suas combinações." },
    ],
  }),
  component: () => <ComprovantesPage />,
});
